import React, { FunctionComponent } from 'react'

import { useField } from 'formik'
import { SpaceProps, WidthProps } from 'styled-system'

import { TextInput } from '@/atoms/input'

import FieldWrapper from './field-wrapper'

export interface TextProps {
  label?: string
  fieldProps?: SpaceProps & WidthProps
  name?: string
  type?: 'text' | 'tel' | 'password'
  disablePaste?: boolean
  isDisabled?: boolean
  hideErrorMessage?: boolean
  onChange?: (val: string) => void
  tooltip?: string
}

const TextField: FunctionComponent<TextProps> = ({
  label,
  fieldProps,
  name,
  type,
  disablePaste,
  isDisabled,
  hideErrorMessage,
  onChange,
  tooltip,
}: TextProps) => {
  const [field, meta] = useField(name)
  const hasError: boolean = meta.touched && !!meta.error

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e)
    if (onChange) {
      onChange(e.target.value)
    }
  }

  return (
    <FieldWrapper id={field.name} meta={meta} label={label} fieldProps={fieldProps} hideErrorMessage={hideErrorMessage} tooltip={tooltip}>
      <TextInput
        id={field.name}
        hasError={hasError}
        type={type}
        disablePaste={disablePaste}
        isDisabled={isDisabled}
        {...field}
        onChange={handleChange}
      />
    </FieldWrapper>
  )
}

TextField.displayName = 'TextField'

export default TextField
